import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=67ebe80e&scoped=true&lang=pug"
import script from "./ExamList.vue?vue&type=script&lang=js"
export * from "./ExamList.vue?vue&type=script&lang=js"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=67ebe80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ebe80e",
  null
  
)

export default component.exports